export const getSpaceJsonLd = (
  space: SpaceType,
  citySlug = 'bogota'
): { __html: string } => {
  const images = [space.profile_image]
    .concat(space.space_images?.map((img) => img.image) || [])
    .filter(Boolean)
    .slice(0, 5);

  const today = new Date();
  const nextMonth = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);

  return {
    __html: `{
    "@context": "https://schema.org",
    "@type": "Event",
    "name": "${space.name}",
    "description": "${space.description
      ?.replace(/"/g, '\\"')
      ?.replace(/\n/g, ' ')}",
    "image": ${JSON.stringify(images)},
    "startDate": "${today.toISOString()}",
    "endDate": "${nextMonth.toISOString()}",
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "location": {
      "@type": "Place",
      "name": "${space.name}",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "${space.street_address?.replace(/"/g, '\\"')}",
        "addressLocality": "${citySlug}",
        "addressCountry": "CO"
      }${
        space.latitude && space.longitude
          ? `,
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "${space.latitude}",
        "longitude": "${space.longitude}"
      }`
          : ''
      }
    },
    "offers": {
      "@type": "Offer",
      "url": "https://tikipal.com.co/${citySlug}/${space.slug}",
      "price": "${space.cover_price || 0}",
      "priceCurrency": "COP",
      "availability": "https://schema.org/InStock",
      "validFrom": "${today.toISOString()}"
    },
    "performer": {
      "@type": "PerformingGroup",
      "name": "${space.name}"
    },
    "organizer": {
      "@type": "Organization",
      "name": "Tikipal",
      "url": "https://tikipal.com.co"
    }
  }
`,
  };
};

// TODO: use this in /about page
export const getOrganizationJsonLd = (): { __html: string } => {
  return {
    __html: `
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Tikipal",
      "legalName": "Tikipal SAS",
      "url": "http://www.tikipal.com.co",
      "logo": "https://tikipal.com.co/logo-circle.svg",
      "foundingDate": "2022",
      "founders": [
        {
          "@type": "Person",
          "name": "Camilo Acosta"
        },
        {
          "@type": "Person",
          "name": "Jobelo Quintero"
        },
        {
          "@type": "Person",
          "name": "Carlos Martinez"
        },
        {
          "@type": "Person",
          "name": "Sebastian Llano"
        }
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "CARRERA 12 140 91",
        "addressRegion": "Bogotá",
        "addressCountry": "Colombia"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "telephone": "[+57-3054584140]",
        "email": "support@tikipal.co"
      },
      "sameAs": [
        "https://www.instagram.com/tikipal.co/"
      ]
    }
`,
    // TODO: add the same as: linkedin, facebook, twitter, instagram, youtube
  };
};
